import './candidateawards.css';
import { Col, Row } from 'react-bootstrap';
import { generateColors } from '../../../../utils/colorUtilsClientInfo';
import MedalIcon from '../../../../assets/images/ic_award.png';
import DownloadCV from '../../../../assets/images/ic_download.png';
import FontAwesome from 'react-fontawesome';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
const CandidateAwardInfoPanel = ({ colorSeed, award, downloadFile }) => {
  if (!award) return null;
  const colours = generateColors(colorSeed);

  return (
    <Row className="candidate-awardInfoContainer mt-1 d-flex">
      <Col xs={2} sm={2} lg={1} className="d-flex justify-content-center">
        <span className="rounded-span" style={{ backgroundColor: colours.backgroundColor, color: colours.color }}>
          <img src={MedalIcon} alt='medal icon' />
        </span>
      </Col>
      <Col xs={10} sm={10} lg={11}>
        <Row>
          <Col xs={12}>
            <span className="title pt-1">
              {award?.title || ''}
            </span>
            {/* <span className="sub-title">
              &nbsp;at&nbsp;{award?.providedBy || ''}
            </span> */}
            {award?.providedBy && (
              <span className="sub-title"> at {award.providedBy}</span>
            )}
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <span className="sub-title1">
              {award?.issueYear || ''}
              {award?.awardDoc?.length > 0 && (
                <Row>
                  <Col xs={12}>

                    {award.awardDoc?.[0]?.originalName}
                    <span
                      onClick={() =>
                        downloadFile(
                          award.awardDoc?.[0]?.path || award.awardDoc?.[0]?.url,
                          award.awardDoc?.[0]?.originalName
                        )
                      }
                      style={{ cursor: 'pointer', marginLeft: '10px' }}
                      className="award-file-link"
                    >
                      <FontAwesomeIcon icon={faDownload} style={{ color: '#F35824', cursor: 'pointer' }} />
                    </span>
                  </Col>
                </Row>
              )}
            </span>
          </Col>
        </Row>

      </Col>
    </Row>
  );
};

export default CandidateAwardInfoPanel;